import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../client';

export interface GlobalSettings {
    id: string;
    email: string | null;
    phone: string | null;
    whatsapp: string | null;
    facebook: string | null;
    instagram: string | null;
    tiktok: string | null;
    youtube: string | null;
    linkedIn: string | null;
    footerDescriptionEn: string | null;
    footerDescriptionAr: string | null;
    addressEn: string | null;
    addressAr: string | null;
}

export const settingsKeys = {
    all: ['settings'] as const,
};

export const useSettings = () => {
    return useQuery({
        queryKey: settingsKeys.all,
        queryFn: async () => {
            const { data } = await api.get<GlobalSettings>('/api/settings');
            return data || null;
        },
    });
};

export const useUpdateSettings = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (newSettings: Partial<GlobalSettings>) => {
            const { data } = await api.put<GlobalSettings>('/api/admin/settings', newSettings);
            return data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: settingsKeys.all });
        },
    });
};
